import React from "react";
import { WarningFilled } from "@ant-design/icons";
import { map } from "lodash";
import { promptVariableToken } from "../../PromptEditor/variables";
import {
  MALFORMED_VARIABLES_LABEL,
  MALFORMED_VARIABLES_MESSAGE,
  MISSING_VARIABLES_LABEL,
  MISSING_VARIABLES_MESSAGE,
  UNKNOWN_VARIABLES_LABEL,
  UNKNOWN_VARIABLES_MESSAGE,
  UNSUPPORTED_MARKDOWN_MESSAGE,
  UNSUPPORTED_MARKDOWN_TITLE,
} from "../configs";
import styles from "./ValidationFooter.module.scss";

interface Props {
  missingRequired: string[];
  unknownVariables: string[];
  malformedVariables: string[];
  unsupported: string[];
}

function VariableList({ names }: { names: string[] }) {
  return (
    <>
      {map(names, (name) => (
        <span key={name} className={styles.blockedVariable}>
          {promptVariableToken(name)}
        </span>
      ))}
    </>
  );
}

function SaveBlockedPanel({ missingRequired, unknownVariables, malformedVariables, unsupported }: Props) {
  return (
    <div className={styles.blockedPanel}>
      {!!unsupported.length && (
        <div className={styles.blockedSection}>
          <div className={styles.blockedHeading}>
            <WarningFilled className={styles.blockedIcon} />
            <span className={styles.blockedHeadingText}>{UNSUPPORTED_MARKDOWN_TITLE}</span>
          </div>
          <div className={styles.blockedMissing}>
            {map(unsupported, (item) => (
              <span key={item} className={styles.blockedVariable}>
                {item}
              </span>
            ))}
          </div>
          <div className={styles.blockedMessage}>{UNSUPPORTED_MARKDOWN_MESSAGE}</div>
        </div>
      )}

      {!!malformedVariables.length && (
        <div className={styles.blockedSection}>
          <div className={styles.blockedHeading}>
            <WarningFilled className={styles.blockedIcon} />
            <span className={styles.blockedHeadingText}>{MALFORMED_VARIABLES_LABEL}</span>
          </div>
          <div className={styles.blockedMissing}>
            {map(malformedVariables, (text) => (
              <span key={text} className={styles.blockedVariable}>
                {text}
              </span>
            ))}
          </div>
          <div className={styles.blockedMessage}>{MALFORMED_VARIABLES_MESSAGE}</div>
        </div>
      )}

      {!!missingRequired.length && (
        <div className={styles.blockedSection}>
          <div className={styles.blockedMissing}>
            <WarningFilled className={styles.blockedIcon} />
            <span className={styles.blockedLabel}>{MISSING_VARIABLES_LABEL}</span>
            <VariableList names={missingRequired} />
          </div>
          <div className={styles.blockedMessage}>{MISSING_VARIABLES_MESSAGE}</div>
        </div>
      )}

      {!!unknownVariables.length && (
        <div className={styles.blockedSection}>
          <div className={styles.blockedHeading}>
            <WarningFilled className={styles.blockedIcon} />
            <span className={styles.blockedHeadingText}>{UNKNOWN_VARIABLES_LABEL}</span>
          </div>
          <div className={styles.blockedMissing}>
            <VariableList names={unknownVariables} />
          </div>
          <div className={styles.blockedMessage}>{UNKNOWN_VARIABLES_MESSAGE}</div>
        </div>
      )}
    </div>
  );
}

export default SaveBlockedPanel;
